module.exports = __webpack_public_path__ + "img/sticker-1-1.2c3aa81e.svg";